{
  "StatvaluestypeLabel": "Ausgabe für Prozent-, Datums-\/Uhrzeit- und Dauerfelder:",
  "StatvaluestypeBothOptionLabel": "[Zwei Werte (formatiert + roh)]",
  "StatvaluestypeMainOptionLabel": "Nur formatierter Anzeigewert (Text)",
  "StatvaluestypeAlternateOptionLabel": "Nur Rohwert (für die grafische Darstellung + Formelverwendung)",
  "CSVExportFormat_SectionHeader": "CSV-Exportformat",
  "CSVExportFormat_SectionPara": "Sie können anpassen, wie Prozent-, Datums-\/Uhrzeit- und Dauerstatistikwerte in CSV-exportierten Berichten generiert werden.",
  "NAME": "CSVExportFormat"
}